// extracted by mini-css-extract-plugin
export default {"language-picker":"rv0n0ze","language-picker__visually-hidden":"MP6MJmz","language-picker__select":"VlpqfqI","language-picker__icon":"KwYnXCG"};